import { Pipe, PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  public override transform(value: any, args?: any): any {
    return super.transform(value, `${environment.defaultDateFormat}`);
  }
}
